import type { SVGProps } from "react";
const SvgCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="#026100"
      d="m6.367 12-3.8-3.8.95-.95 2.85 2.85 6.116-6.117.95.95z"
    />
  </svg>
);
export default SvgCheck;
